module.exports = __webpack_public_path__ + "img/ameba.bc2c393a.png";